import dayjs from "dayjs";
import { FranchiseOpportunity } from "../../../types/Location";

export interface StandardSelectionProp {
  franchiseOpportunity: FranchiseOpportunity;
}

function StandardSelection({ franchiseOpportunity }: StandardSelectionProp) {
  const {
    recruitPhase1Date,
    recruitPhase2Date,
    recruitPhase3Date,
    recruitPhase4Date,
    recruitPhase5Date,
  } = franchiseOpportunity;

  return (
    <svg
      width="364"
      height="796"
      viewBox="0 0 364 796"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", margin: "auto" }}
    >
      <text
        fill="#004F71"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="133.03335" y="21.76">
          Relocation&#10;
        </tspan>
        <tspan x="75.175" y="53.76">
          Activation and Timeline
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="14"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="147.321" y="84.032">
          ~16 WEEKS
        </tspan>
      </text>
      <line
        x1="103.881"
        y1="158"
        x2="103.881"
        y2="746"
        stroke="#DD0031"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="0.25 10"
      />
      <rect x="82" y="750" width="44" height="44" rx="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.1266 772C94.1266 766.547 98.5471 762.127 104 762.127C109.453 762.127 113.873 766.547 113.873 772C113.873 777.453 109.453 781.873 104 781.873C98.5471 781.873 94.1266 777.453 94.1266 772ZM104 760C97.3726 760 92 765.373 92 772C92 778.627 97.3726 784 104 784C110.627 784 116 778.627 116 772C116 765.373 110.627 760 104 760ZM108.397 770.321C108.813 769.906 108.813 769.233 108.397 768.818C107.982 768.403 107.309 768.403 106.894 768.818L102.785 772.927L101.106 771.248C100.691 770.833 100.018 770.833 99.6026 771.248C99.1873 771.663 99.1873 772.337 99.6026 772.752L102.033 775.182C102.448 775.597 103.121 775.597 103.537 775.182L108.397 770.321Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="750"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="777.76">
          Select
        </tspan>
      </text>
      <rect x="82" y="598" width="44" height="44" rx="22" fill="white" />
      <g clip-path="url(#clip0_2_443)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.4 617.6C94.4 613.624 97.6235 610.4 101.6 610.4C105.576 610.4 108.8 613.624 108.8 617.6C108.8 621.576 105.576 624.8 101.6 624.8C97.6235 624.8 94.4 621.576 94.4 617.6ZM101.6 608C96.2981 608 92 612.298 92 617.6C92 622.902 96.2981 627.2 101.6 627.2C103.818 627.2 105.861 626.447 107.487 625.184L113.951 631.649C114.42 632.117 115.18 632.117 115.649 631.649C116.117 631.18 116.117 630.42 115.649 629.951L109.184 623.487C110.447 621.861 111.2 619.818 111.2 617.6C111.2 612.298 106.902 608 101.6 608Z"
          fill="#DD0031"
        />
      </g>
      <rect
        x="82"
        y="598"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="593.76">
          Assess&#10;
        </tspan>
        <tspan x="136" y="625.76">
          Decide&#10;
        </tspan>
        <tspan x="136" y="657.76">
          Communicate
        </tspan>
      </text>
      <rect x="82" y="406" width="44" height="44" rx="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.497 417.569C103.382 417.496 103.259 417.439 103.129 417.4C102.799 417.321 102.457 417.312 102.124 417.374C101.525 417.417 101.033 417.87 100.933 418.472C100.91 418.565 100.895 418.661 100.879 418.765C100.872 418.808 100.866 418.852 100.858 418.898C100.66 418.898 100.469 418.896 100.278 418.894C99.9007 418.891 99.5279 418.887 99.1235 418.898C99.0386 418.9 98.9692 418.967 98.9641 419.054C98.9524 419.283 98.9605 419.74 98.969 420.211C98.9746 420.527 98.9803 420.849 98.9803 421.114C98.9821 421.204 99.0544 421.276 99.143 421.276H105.915C106.005 421.276 106.077 421.202 106.077 421.11V419.054C106.077 419.01 106.06 418.968 106.03 418.938C105.999 418.907 105.957 418.891 105.915 418.891H104.197C104.19 418.837 104.18 418.788 104.172 418.743C104.159 418.678 104.148 418.619 104.148 418.561C104.081 418.15 103.844 417.789 103.497 417.569ZM103.042 419.404C102.902 419.54 102.715 419.614 102.521 419.609C102.323 419.61 102.133 419.528 101.997 419.382C101.861 419.236 101.79 419.039 101.802 418.839C101.803 418.645 101.881 418.46 102.019 418.326C102.156 418.192 102.34 418.119 102.531 418.124C102.728 418.121 102.918 418.2 103.057 418.343C103.195 418.486 103.27 418.681 103.263 418.882C103.261 419.079 103.181 419.267 103.042 419.404Z"
        fill="#DD0031"
      />
      <path
        d="M99.3642 429.55H97.9422C97.6564 429.55 97.4248 429.315 97.4248 429.024C97.4248 428.734 97.6564 428.498 97.9422 428.498H99.1429L100.119 427.44C100.27 427.279 100.504 427.232 100.705 427.321L101.837 427.837L103.194 426.56C103.398 426.364 103.719 426.372 103.913 426.577L104.89 427.569L106.842 424.563C106.93 424.376 107.118 424.26 107.322 424.266C107.526 424.271 107.708 424.398 107.786 424.589C107.864 424.781 107.824 425.001 107.685 425.152L105.407 428.703C105.321 428.836 105.181 428.922 105.026 428.938C104.871 428.952 104.717 428.895 104.606 428.783L103.542 427.678L102.303 428.842C102.152 428.988 101.929 429.026 101.74 428.938L100.63 428.432L99.7384 429.385C99.6417 429.49 99.5061 429.55 99.3642 429.55Z"
        fill="#DD0031"
      />
      <path
        d="M107.502 436.111C107.345 436.11 107.195 436.044 107.086 435.929L103.695 432.311C103.542 432.162 103.483 431.94 103.539 431.732C103.596 431.525 103.76 431.366 103.967 431.318C104.173 431.271 104.389 431.342 104.528 431.504L107.424 434.593L112.279 427.255C112.396 427.082 112.594 426.985 112.799 427.001C113.005 427.016 113.187 427.143 113.276 427.331C113.366 427.52 113.349 427.743 113.233 427.916L107.981 435.853C107.884 436.001 107.725 436.096 107.551 436.111H107.502Z"
        fill="#DD0031"
      />
      <path
        d="M95.7955 433.363C95.9571 433.355 96.0822 433.216 96.075 433.052C96.0677 432.888 95.9309 432.761 95.7693 432.768C95.6077 432.776 95.4824 432.914 95.4894 433.079C95.4928 433.158 95.527 433.232 95.5844 433.285C95.6418 433.339 95.7178 433.367 95.7955 433.363V433.363Z"
        fill="#DD0031"
      />
      <path
        d="M97.4446 433.294C97.5633 433.289 97.6678 433.213 97.7092 433.1C97.7506 432.987 97.7207 432.859 97.6335 432.778C97.5463 432.696 97.419 432.675 97.3113 432.726C97.2035 432.777 97.1366 432.889 97.1418 433.009C97.1488 433.172 97.2839 433.299 97.4446 433.294V433.294Z"
        fill="#DD0031"
      />
      <path
        d="M94.9945 433.661C94.8329 433.668 94.7078 433.807 94.715 433.971C94.7223 434.135 94.8591 434.262 95.0207 434.255C95.1823 434.248 95.3076 434.109 95.3006 433.945C95.2972 433.866 95.263 433.792 95.2056 433.738C95.1482 433.685 95.0722 433.657 94.9945 433.661Z"
        fill="#DD0031"
      />
      <path
        d="M96.6604 433.591C96.4992 433.598 96.3742 433.737 96.3807 433.901C96.3873 434.064 96.523 434.192 96.6843 434.186C96.8455 434.18 96.9717 434.043 96.9665 433.879C96.9639 433.799 96.9302 433.724 96.8726 433.67C96.8151 433.616 96.7387 433.588 96.6604 433.591V433.591Z"
        fill="#DD0031"
      />
      <path
        d="M95.8605 434.484C95.7558 434.488 95.6612 434.549 95.6124 434.643C95.5636 434.737 95.5679 434.85 95.6238 434.94C95.6797 435.031 95.7786 435.083 95.8833 435.079C95.9608 435.077 96.034 435.043 96.0866 434.985C96.1392 434.927 96.1669 434.85 96.1633 434.772C96.1608 434.693 96.1274 434.618 96.0706 434.564C96.0138 434.51 95.9382 434.481 95.8605 434.484V434.484Z"
        fill="#DD0031"
      />
      <path
        d="M97.5098 434.418C97.3481 434.425 97.223 434.564 97.2303 434.729C97.2375 434.893 97.3743 435.02 97.536 435.013C97.6976 435.005 97.8229 434.866 97.8158 434.702C97.8125 434.623 97.7783 434.549 97.7209 434.496C97.6635 434.442 97.5875 434.414 97.5098 434.418V434.418Z"
        fill="#DD0031"
      />
      <path
        d="M95.0562 435.37C94.8943 435.377 94.7682 435.515 94.7745 435.68C94.7808 435.844 94.9171 435.972 95.079 435.966C95.1837 435.961 95.2783 435.901 95.3271 435.807C95.3759 435.713 95.3716 435.599 95.3157 435.509C95.2598 435.419 95.1609 435.366 95.0562 435.37V435.37Z"
        fill="#DD0031"
      />
      <path
        d="M96.7091 435.301C96.6044 435.305 96.5099 435.366 96.461 435.46C96.4122 435.554 96.4166 435.667 96.4724 435.757C96.5283 435.847 96.6272 435.9 96.7319 435.896C96.8938 435.89 97.0199 435.751 97.0136 435.587C97.0073 435.423 96.871 435.294 96.7091 435.301V435.301Z"
        fill="#DD0031"
      />
      <path
        d="M99.1433 433.363C99.2621 433.359 99.3666 433.282 99.408 433.169C99.4494 433.056 99.4195 432.929 99.3323 432.847C99.245 432.765 99.1178 432.745 99.01 432.795C98.9022 432.846 98.8353 432.958 98.8405 433.079C98.8492 433.241 98.9833 433.367 99.1433 433.363V433.363Z"
        fill="#DD0031"
      />
      <path
        d="M100.796 433.294C100.874 433.291 100.947 433.257 101 433.199C101.052 433.141 101.08 433.065 101.076 432.986C101.072 432.865 100.997 432.759 100.886 432.717C100.774 432.675 100.649 432.706 100.568 432.794C100.488 432.883 100.468 433.012 100.518 433.121C100.568 433.231 100.678 433.299 100.796 433.294V433.294Z"
        fill="#DD0031"
      />
      <path
        d="M98.3589 433.661C98.1973 433.668 98.0722 433.807 98.0794 433.971C98.0866 434.135 98.2235 434.262 98.3851 434.255C98.5467 434.248 98.672 434.109 98.665 433.945C98.6616 433.866 98.6274 433.792 98.57 433.738C98.5126 433.685 98.4366 433.657 98.3589 433.661Z"
        fill="#DD0031"
      />
      <path
        d="M100.009 433.591C99.8476 433.598 99.7226 433.737 99.7291 433.901C99.7357 434.064 99.8714 434.192 100.033 434.186C100.194 434.18 100.32 434.043 100.315 433.879C100.312 433.799 100.279 433.724 100.221 433.67C100.164 433.616 100.087 433.588 100.009 433.591Z"
        fill="#DD0031"
      />
      <path
        d="M99.2244 434.484C99.0631 434.491 98.9381 434.63 98.9447 434.793C98.9513 434.957 99.087 435.085 99.2482 435.079C99.4095 435.073 99.5357 434.936 99.5304 434.772C99.5279 434.692 99.4941 434.617 99.4366 434.563C99.3791 434.509 99.3026 434.48 99.2244 434.484V434.484Z"
        fill="#DD0031"
      />
      <path
        d="M100.852 434.418C100.733 434.422 100.628 434.499 100.587 434.612C100.545 434.725 100.575 434.852 100.663 434.934C100.75 435.016 100.877 435.036 100.985 434.985C101.093 434.935 101.16 434.823 101.154 434.702C101.146 434.54 101.012 434.414 100.852 434.418V434.418Z"
        fill="#DD0031"
      />
      <path
        d="M98.4079 435.37C98.2892 435.374 98.1847 435.451 98.1433 435.564C98.1019 435.677 98.1318 435.804 98.219 435.886C98.3062 435.968 98.4335 435.989 98.5412 435.938C98.649 435.887 98.716 435.775 98.7107 435.655C98.7037 435.492 98.5686 435.365 98.4079 435.37V435.37Z"
        fill="#DD0031"
      />
      <path
        d="M100.058 435.301C99.896 435.308 99.7709 435.447 99.7781 435.611C99.7854 435.776 99.9222 435.903 100.084 435.896C100.245 435.888 100.371 435.749 100.364 435.585C100.36 435.506 100.326 435.432 100.269 435.379C100.211 435.325 100.135 435.297 100.058 435.301V435.301Z"
        fill="#DD0031"
      />
      <path
        d="M102.495 433.363C102.656 433.356 102.781 433.217 102.774 433.053C102.768 432.89 102.632 432.762 102.471 432.768C102.31 432.774 102.183 432.911 102.189 433.075C102.191 433.155 102.225 433.23 102.282 433.284C102.34 433.338 102.416 433.367 102.495 433.363V433.363Z"
        fill="#DD0031"
      />
      <path
        d="M101.707 433.661C101.63 433.663 101.557 433.697 101.504 433.755C101.452 433.813 101.424 433.889 101.427 433.968C101.431 434.089 101.507 434.195 101.618 434.237C101.73 434.279 101.855 434.249 101.935 434.16C102.016 434.071 102.036 433.942 101.986 433.833C101.936 433.723 101.826 433.655 101.707 433.661V433.661Z"
        fill="#DD0031"
      />
      <path
        d="M103.36 433.591C103.199 433.598 103.074 433.737 103.081 433.901C103.087 434.064 103.223 434.192 103.384 434.186C103.545 434.18 103.672 434.043 103.666 433.879C103.664 433.799 103.63 433.724 103.573 433.67C103.515 433.616 103.439 433.588 103.36 433.591V433.591Z"
        fill="#DD0031"
      />
      <path
        d="M102.56 434.484C102.455 434.488 102.361 434.549 102.312 434.643C102.263 434.737 102.267 434.85 102.323 434.94C102.379 435.03 102.478 435.083 102.583 435.079C102.744 435.073 102.871 434.934 102.864 434.77C102.858 434.606 102.722 434.478 102.56 434.484Z"
        fill="#DD0031"
      />
      <path
        d="M104.21 434.418C104.048 434.425 103.923 434.564 103.93 434.729C103.938 434.893 104.074 435.02 104.236 435.013C104.398 435.005 104.523 434.866 104.516 434.702C104.513 434.623 104.478 434.549 104.421 434.496C104.364 434.442 104.288 434.414 104.21 434.418V434.418Z"
        fill="#DD0031"
      />
      <path
        d="M101.756 435.37C101.679 435.373 101.605 435.407 101.553 435.465C101.5 435.522 101.472 435.599 101.476 435.678C101.48 435.798 101.555 435.905 101.667 435.947C101.778 435.989 101.903 435.958 101.984 435.87C102.065 435.781 102.085 435.652 102.035 435.542C101.985 435.433 101.875 435.365 101.756 435.37V435.37Z"
        fill="#DD0031"
      />
      <path
        d="M103.409 435.301C103.29 435.305 103.186 435.381 103.144 435.495C103.103 435.608 103.133 435.735 103.22 435.817C103.307 435.899 103.435 435.919 103.542 435.868C103.65 435.818 103.717 435.706 103.712 435.585C103.703 435.423 103.569 435.297 103.409 435.301V435.301Z"
        fill="#DD0031"
      />
      <path
        d="M105.108 435.37C104.989 435.374 104.884 435.451 104.843 435.564C104.802 435.677 104.832 435.804 104.919 435.886C105.006 435.968 105.133 435.989 105.241 435.938C105.349 435.887 105.416 435.775 105.411 435.655C105.404 435.492 105.268 435.365 105.108 435.37V435.37Z"
        fill="#DD0031"
      />
      <path
        d="M96.055 437.024C96.1751 437.02 96.2808 436.942 96.3227 436.828C96.3646 436.714 96.3344 436.585 96.2463 436.502C96.1581 436.419 96.0294 436.399 95.9205 436.45C95.8115 436.501 95.7437 436.614 95.7489 436.736C95.7515 436.816 95.7853 436.891 95.8428 436.945C95.9003 436.999 95.9767 437.027 96.055 437.024V437.024Z"
        fill="#DD0031"
      />
      <path
        d="M97.705 436.954C97.8237 436.95 97.9282 436.874 97.9696 436.761C98.011 436.648 97.9811 436.52 97.8939 436.438C97.8067 436.356 97.6794 436.336 97.5716 436.387C97.4639 436.438 97.3969 436.549 97.4021 436.67C97.4109 436.832 97.545 436.958 97.705 436.954Z"
        fill="#DD0031"
      />
      <path
        d="M95.2678 437.318C95.1066 437.325 94.9816 437.464 94.9882 437.628C94.9947 437.791 95.1304 437.919 95.2917 437.913C95.453 437.907 95.5791 437.77 95.5739 437.606C95.5714 437.526 95.5376 437.451 95.4801 437.397C95.4225 437.343 95.3461 437.315 95.2678 437.318V437.318Z"
        fill="#DD0031"
      />
      <path
        d="M96.9207 437.252C96.7823 437.284 96.6862 437.412 96.6926 437.556C96.699 437.7 96.8061 437.818 96.9467 437.837C97.1086 437.831 97.2347 437.692 97.2284 437.528C97.2221 437.364 97.0858 437.236 96.924 437.242L96.9207 437.252Z"
        fill="#DD0031"
      />
      <path
        d="M99.4036 437.024C99.524 437.021 99.6307 436.944 99.6736 436.83C99.7166 436.716 99.6872 436.587 99.5992 436.503C99.5113 436.42 99.3823 436.398 99.2729 436.45C99.1635 436.501 99.0955 436.614 99.1007 436.736C99.1078 436.9 99.2424 437.028 99.4036 437.024V437.024Z"
        fill="#DD0031"
      />
      <path
        d="M101.056 436.954C101.218 436.947 101.343 436.808 101.336 436.644C101.329 436.48 101.192 436.352 101.03 436.36C100.869 436.367 100.743 436.506 100.75 436.67C100.754 436.749 100.788 436.823 100.845 436.877C100.903 436.93 100.979 436.958 101.056 436.954V436.954Z"
        fill="#DD0031"
      />
      <path
        d="M98.6193 437.318C98.458 437.325 98.333 437.464 98.3396 437.628C98.3462 437.791 98.4819 437.919 98.6431 437.913C98.8044 437.907 98.9306 437.77 98.9253 437.606C98.9183 437.441 98.7817 437.313 98.6193 437.318V437.318Z"
        fill="#DD0031"
      />
      <path
        d="M100.269 437.252C100.108 437.259 99.9824 437.398 99.9897 437.563C99.9969 437.727 100.134 437.854 100.295 437.847C100.457 437.839 100.582 437.701 100.575 437.536C100.572 437.457 100.538 437.383 100.48 437.33C100.423 437.276 100.347 437.248 100.269 437.252V437.252Z"
        fill="#DD0031"
      />
      <path
        d="M102.755 437.024C102.875 437.02 102.981 436.942 103.023 436.828C103.065 436.714 103.034 436.585 102.946 436.502C102.858 436.419 102.73 436.399 102.621 436.45C102.512 436.501 102.444 436.614 102.449 436.736C102.452 436.816 102.485 436.891 102.543 436.945C102.6 436.999 102.677 437.027 102.755 437.024Z"
        fill="#DD0031"
      />
      <path
        d="M104.405 436.954C104.524 436.95 104.628 436.874 104.67 436.761C104.711 436.648 104.681 436.52 104.594 436.438C104.507 436.356 104.379 436.336 104.272 436.387C104.164 436.438 104.097 436.549 104.102 436.67C104.111 436.832 104.245 436.958 104.405 436.954V436.954Z"
        fill="#DD0031"
      />
      <path
        d="M101.968 437.318C101.806 437.325 101.681 437.464 101.688 437.628C101.694 437.791 101.83 437.919 101.991 437.913C102.153 437.907 102.279 437.77 102.274 437.606C102.271 437.526 102.237 437.451 102.18 437.397C102.122 437.343 102.046 437.315 101.968 437.318V437.318Z"
        fill="#DD0031"
      />
      <path
        d="M103.621 437.252C103.459 437.258 103.333 437.397 103.339 437.561C103.345 437.726 103.482 437.854 103.643 437.847C103.748 437.843 103.843 437.783 103.892 437.688C103.94 437.594 103.936 437.481 103.88 437.391C103.824 437.301 103.725 437.248 103.621 437.252Z"
        fill="#DD0031"
      />
      <path
        d="M106.103 437.02C106.222 437.016 106.327 436.94 106.368 436.827C106.409 436.714 106.38 436.586 106.292 436.505C106.205 436.423 106.078 436.402 105.97 436.453C105.862 436.504 105.795 436.616 105.801 436.736C105.808 436.899 105.943 437.026 106.103 437.02V437.02Z"
        fill="#DD0031"
      />
      <path
        d="M105.319 437.318C105.158 437.325 105.033 437.464 105.04 437.628C105.046 437.791 105.182 437.919 105.343 437.913C105.504 437.907 105.631 437.77 105.625 437.606C105.618 437.441 105.482 437.313 105.319 437.318V437.318Z"
        fill="#DD0031"
      />
      <path
        d="M106.969 437.252C106.807 437.259 106.682 437.398 106.69 437.563C106.697 437.727 106.834 437.854 106.995 437.847C107.157 437.839 107.282 437.701 107.275 437.536C107.272 437.457 107.238 437.383 107.18 437.33C107.123 437.276 107.047 437.248 106.969 437.252V437.252Z"
        fill="#DD0031"
      />
      <path
        d="M109.455 437.02C109.533 437.018 109.606 436.984 109.659 436.926C109.711 436.868 109.739 436.792 109.735 436.713C109.731 436.592 109.656 436.486 109.545 436.444C109.433 436.402 109.308 436.433 109.227 436.521C109.147 436.61 109.127 436.739 109.176 436.848C109.226 436.958 109.337 437.026 109.455 437.02V437.02Z"
        fill="#DD0031"
      />
      <path
        d="M108.661 437.318C108.5 437.325 108.375 437.464 108.381 437.628C108.388 437.791 108.524 437.919 108.685 437.913C108.846 437.907 108.972 437.77 108.967 437.606C108.965 437.526 108.931 437.451 108.873 437.397C108.816 437.343 108.739 437.315 108.661 437.318V437.318Z"
        fill="#DD0031"
      />
      <path
        d="M106.816 420.912V420.912C106.836 420.95 106.86 420.986 106.888 421.018L106.91 421.054C107 421.149 107.123 421.203 107.252 421.203H108.746C108.943 421.179 109.141 421.247 109.283 421.39C109.424 421.532 109.494 421.733 109.471 421.934C109.471 421.934 109.471 429.13 109.471 429.143C109.471 429.156 109.471 429.209 109.471 429.236C109.471 429.262 109.471 429.259 109.471 429.269C109.518 429.48 109.703 429.629 109.915 429.629C110.128 429.629 110.312 429.48 110.36 429.269C110.371 429.223 110.378 429.177 110.382 429.13V421.891C110.389 421.458 110.222 421.04 109.922 420.734C109.621 420.427 109.211 420.256 108.785 420.261H107.242C107.053 420.261 106.882 420.376 106.806 420.552C106.783 420.612 106.771 420.676 106.77 420.74V420.74C106.775 420.8 106.79 420.858 106.816 420.912Z"
        fill="#DD0031"
      />
      <path
        d="M110.005 434.405C109.882 434.386 109.756 434.418 109.657 434.494C109.557 434.569 109.491 434.683 109.474 434.808C109.474 434.98 109.474 436.991 109.474 436.991C109.497 437.191 109.428 437.391 109.287 437.533C109.146 437.676 108.949 437.745 108.752 437.722H96.3575C95.8271 437.722 95.5928 437.487 95.5928 436.951C95.5928 435.42 95.5928 433.892 95.5928 432.361V421.914C95.5768 421.72 95.6457 421.529 95.7812 421.391C95.9166 421.254 96.1048 421.184 96.2957 421.2H97.8251C98.0856 421.2 98.2969 420.985 98.2969 420.72C98.2969 420.455 98.0856 420.241 97.8251 420.241L96.2957 420.261C95.8575 420.247 95.4335 420.42 95.1251 420.736C94.8166 421.053 94.6513 421.485 94.6687 421.931V436.968C94.6458 437.426 94.8157 437.873 95.136 438.196C95.4563 438.52 95.8968 438.69 96.3477 438.664H108.713C109.164 438.69 109.604 438.52 109.924 438.196C110.244 437.872 110.413 437.426 110.389 436.968C110.389 436.968 110.418 435.03 110.418 434.831C110.421 434.718 110.378 434.609 110.3 434.529C110.222 434.449 110.116 434.404 110.005 434.405Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="406"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="433.76">
          Narrow
        </tspan>
      </text>
      <rect x="82" y="294" width="44" height="44" rx="22" fill="white" />
      <ellipse
        cx="99.7268"
        cy="307.79"
        rx="0.455704"
        ry="0.450937"
        fill="#DD0031"
      />
      <ellipse
        cx="102.217"
        cy="307.79"
        rx="0.455704"
        ry="0.450937"
        fill="#DD0031"
      />
      <path
        d="M105.043 308.241C105.228 308.242 105.395 308.133 105.467 307.965C105.539 307.796 105.501 307.602 105.371 307.472C105.241 307.342 105.044 307.303 104.873 307.373C104.703 307.442 104.591 307.607 104.591 307.79C104.591 308.037 104.793 308.239 105.043 308.241V308.241Z"
        fill="#DD0031"
      />
      <path
        d="M107.533 308.241C107.718 308.242 107.885 308.133 107.957 307.965C108.028 307.796 107.99 307.602 107.86 307.472C107.73 307.342 107.534 307.303 107.363 307.373C107.192 307.442 107.081 307.607 107.081 307.79C107.081 308.037 107.283 308.239 107.533 308.241V308.241Z"
        fill="#DD0031"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.347 310.137C114.841 310.193 115.293 310.443 115.599 310.833C116.238 311.635 116.099 312.799 115.287 313.432L113.991 314.455L114.732 315.379C114.917 315.617 114.874 315.958 114.635 316.145L110.931 319.052V326.117C110.931 326.42 110.682 326.667 110.375 326.667H97.2224C96.9154 326.667 96.6666 326.42 96.6666 326.117V305.883C96.6666 305.58 96.9154 305.333 97.2224 305.333H110.375C110.677 305.339 110.919 305.584 110.919 305.883V312.149L112.968 310.536C113.355 310.225 113.852 310.081 114.347 310.137ZM97.9856 306.433H97.7781V309.043H98.0041C98.0558 308.851 98.2322 308.716 98.4339 308.716C98.6356 308.716 98.812 308.851 98.8637 309.043H100.494C100.545 308.851 100.722 308.716 100.924 308.716C101.125 308.716 101.302 308.851 101.353 309.043H103.324C103.373 308.849 103.55 308.712 103.752 308.712C103.955 308.712 104.131 308.849 104.18 309.043H105.81C105.862 308.851 106.038 308.716 106.24 308.716C106.442 308.716 106.618 308.851 106.67 309.043H108.656C108.707 308.851 108.884 308.716 109.085 308.716C109.287 308.716 109.464 308.851 109.515 309.043H109.856V306.433H109.534C109.535 306.443 109.535 306.453 109.534 306.463C109.549 306.633 109.466 306.797 109.32 306.887C109.173 306.977 108.987 306.977 108.84 306.887C108.693 306.797 108.611 306.633 108.626 306.463V306.433H106.725C106.727 306.443 106.727 306.453 106.725 306.463C106.741 306.633 106.658 306.797 106.511 306.887C106.364 306.977 106.179 306.977 106.032 306.887C105.885 306.797 105.802 306.633 105.818 306.463V306.433H104.228V306.463C104.244 306.633 104.161 306.797 104.014 306.887C103.867 306.977 103.682 306.977 103.535 306.887C103.388 306.797 103.305 306.633 103.321 306.463V306.433H101.39V306.463C101.406 306.633 101.323 306.797 101.176 306.887C101.029 306.977 100.844 306.977 100.697 306.887C100.55 306.797 100.467 306.633 100.483 306.463C100.481 306.453 100.481 306.443 100.483 306.433H98.8896V306.463C98.8604 306.688 98.6668 306.856 98.4376 306.856C98.2083 306.856 98.0148 306.688 97.9856 306.463V306.433ZM109.808 325.567H97.7781V310.169H109.808V313.032L102.643 318.667C102.572 318.723 102.517 318.795 102.48 318.876L101.583 320.889C101.53 321.018 101.53 321.163 101.583 321.292L101.001 321.75C100.761 321.94 100.721 322.286 100.912 322.524C101.104 322.762 101.454 322.801 101.694 322.612L102.268 322.157C102.36 322.22 102.468 322.255 102.58 322.256C102.631 322.256 102.682 322.249 102.732 322.234L104.788 321.666C104.859 321.646 104.926 321.612 104.984 321.567L109.801 317.758L109.808 325.567ZM104.51 320.526L109.808 316.354L110.919 315.478L112.45 314.271L111.52 313.084L110.919 313.553L109.808 314.429L103.536 319.371L104.51 320.526ZM110.919 317.648V316.882L113.142 315.14L113.513 315.621L110.919 317.648ZM114.606 312.574C114.766 312.451 114.867 312.268 114.887 312.068H114.906C114.961 311.76 114.811 311.451 114.535 311.3C114.258 311.148 113.914 311.187 113.68 311.397L112.409 312.398L113.339 313.586L114.606 312.574Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="294"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="310.76">
          Application&#10;
        </tspan>
        <tspan x="136" y="342.76">
          Review
        </tspan>
      </text>
      <rect x="82" y="202" width="44" height="44" rx="22" fill="white" />
      <ellipse
        cx="98.5937"
        cy="227.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <ellipse
        cx="101.399"
        cy="227.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <ellipse
        cx="104.2"
        cy="227.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.761 223.202C114.344 222.276 114.657 221.203 114.667 220.105C114.667 216.365 111.048 213.333 106.601 213.333C102.155 213.333 98.5395 216.365 98.5395 220.088C98.5398 220.581 98.6037 221.073 98.7295 221.55C95.5922 222.472 93.3334 224.98 93.3334 227.922C93.3396 229.026 93.6535 230.106 94.2389 231.036L93.3707 233.978C93.3096 234.178 93.3709 234.395 93.5267 234.532C93.621 234.615 93.7411 234.661 93.8659 234.663C93.9405 234.664 94.0145 234.648 94.0829 234.618L96.725 233.428C98.1451 234.255 99.7575 234.683 101.395 234.666C105.842 234.666 109.461 231.638 109.461 227.912C109.461 227.421 109.399 226.931 109.274 226.456C109.975 226.253 110.648 225.963 111.278 225.593L113.917 226.797C114.106 226.879 114.324 226.846 114.48 226.711C114.636 226.574 114.697 226.357 114.636 226.157L113.761 223.202ZM101.395 233.61C99.865 233.622 98.3628 233.193 97.0642 232.371C96.9801 232.317 96.8824 232.288 96.7827 232.289C96.7079 232.29 96.6341 232.306 96.5656 232.337L94.707 233.176L95.3209 231.112C95.3646 230.957 95.3385 230.791 95.2497 230.658C94.6951 229.856 94.3946 228.902 94.3882 227.922C94.3882 225.328 96.5419 223.14 99.4757 222.458C99.4926 222.46 99.5096 222.46 99.5265 222.458C99.9728 222.355 100.426 222.289 100.883 222.259C101.015 222.259 101.148 222.259 101.28 222.242H101.426C105.282 222.242 108.413 224.798 108.413 227.926C108.413 231.053 105.262 233.61 101.395 233.61ZM112.898 221.93C113.002 221.862 113.133 221.855 113.242 221.911V221.904C113.48 221.33 113.604 220.714 113.605 220.091C113.601 219.501 113.486 218.917 113.266 218.371C113.208 218.413 113.14 218.437 113.069 218.439C112.882 218.439 112.73 218.285 112.73 218.095C112.724 217.937 112.825 217.795 112.974 217.751C112.792 217.426 112.577 217.121 112.333 216.84C112.435 216.978 112.428 217.169 112.318 217.299C112.207 217.43 112.022 217.465 111.872 217.385C111.722 217.304 111.647 217.128 111.692 216.962C111.737 216.796 111.889 216.684 112.059 216.692C112.137 216.693 112.213 216.722 112.272 216.774C111.996 216.466 111.69 216.186 111.36 215.938C111.362 215.957 111.362 215.977 111.36 215.997C111.36 216.187 111.208 216.341 111.021 216.341C110.833 216.341 110.682 216.187 110.682 215.997C110.68 215.825 110.803 215.678 110.97 215.652C110.729 215.497 110.48 215.356 110.224 215.229C110.164 215.28 110.088 215.308 110.01 215.308C109.83 215.309 109.682 215.167 109.671 214.985C108.697 214.604 107.662 214.411 106.618 214.417C105.796 214.413 104.977 214.529 104.187 214.761C104.283 214.872 104.298 215.033 104.225 215.161C104.152 215.289 104.007 215.355 103.864 215.326C103.677 215.326 103.525 215.172 103.525 214.981C101.687 215.714 100.29 217.087 99.7945 218.749C99.9818 218.749 100.134 218.903 100.134 219.093C100.134 219.283 99.9818 219.437 99.7945 219.437C99.7399 219.436 99.6864 219.422 99.6385 219.396C99.6045 219.624 99.5863 219.854 99.5842 220.084C99.5846 220.34 99.6073 220.596 99.652 220.848C99.6972 220.829 99.7455 220.818 99.7945 220.817C99.9818 220.817 100.134 220.971 100.134 221.161C100.132 221.19 100.126 221.219 100.117 221.247C100.544 221.191 100.975 221.163 101.405 221.165H101.507C101.507 220.975 101.659 220.82 101.846 220.82C102.034 220.82 102.186 220.975 102.186 221.165V221.192C102.674 221.228 103.16 221.302 103.637 221.412C103.542 221.299 103.53 221.136 103.607 221.009C103.685 220.882 103.834 220.82 103.977 220.856C104.119 220.891 104.223 221.016 104.234 221.165C104.238 221.328 104.129 221.471 103.973 221.509C106.222 222.125 108.063 223.539 108.942 225.417C109.192 225.344 109.439 225.258 109.681 225.159C109.734 225.028 109.86 224.944 110 224.946C110.041 224.947 110.081 224.955 110.119 224.97C110.371 224.85 110.617 224.715 110.855 224.568C110.716 224.482 110.657 224.309 110.713 224.155C110.769 224.001 110.925 223.908 111.085 223.934C111.245 223.96 111.364 224.097 111.37 224.261C111.368 224.326 111.35 224.389 111.316 224.444C111.357 224.451 111.397 224.464 111.435 224.481L113.276 225.321L113.069 224.633C112.979 224.633 112.893 224.597 112.829 224.532C112.766 224.468 112.73 224.38 112.73 224.289C112.732 224.17 112.793 224.061 112.893 224L112.666 223.267C112.627 223.112 112.658 222.948 112.75 222.82C112.815 222.727 112.873 222.63 112.93 222.534C112.821 222.477 112.749 222.366 112.742 222.241C112.736 222.117 112.795 221.998 112.898 221.93Z"
        fill="#DD0031"
      />
      <path
        d="M113.079 219.785C112.892 219.785 112.74 219.939 112.74 220.129C112.74 220.319 112.892 220.473 113.079 220.473C113.267 220.473 113.419 220.319 113.419 220.129C113.419 219.939 113.267 219.785 113.079 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 218.749C111.871 218.749 111.719 218.903 111.719 219.093C111.719 219.283 111.871 219.437 112.059 219.437C112.246 219.437 112.398 219.283 112.398 219.093C112.398 218.903 112.246 218.749 112.059 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 220.82C111.871 220.82 111.719 220.975 111.719 221.165C111.719 221.355 111.871 221.509 112.059 221.509C112.246 221.509 112.398 221.355 112.398 221.165C112.398 220.975 112.246 220.82 112.059 220.82Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 222.895C111.871 222.895 111.719 223.049 111.719 223.239C111.719 223.429 111.871 223.583 112.059 223.583C112.246 223.583 112.398 223.429 112.398 223.239C112.398 223.049 112.246 222.895 112.059 222.895Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 215.639C108.805 215.639 108.653 215.793 108.653 215.983C108.653 216.173 108.805 216.327 108.992 216.327C109.18 216.327 109.332 216.173 109.332 215.983C109.332 215.793 109.18 215.639 108.992 215.639Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 214.603C107.784 214.603 107.632 214.757 107.632 214.947C107.632 215.137 107.784 215.291 107.971 215.291C108.159 215.291 108.311 215.137 108.311 214.947C108.311 214.757 108.159 214.603 107.971 214.603V214.603Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 216.674C109.826 216.674 109.674 216.828 109.674 217.018C109.674 217.208 109.826 217.363 110.013 217.363C110.201 217.363 110.353 217.208 110.353 217.018C110.353 216.828 110.201 216.674 110.013 216.674Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 216.674C107.784 216.674 107.632 216.828 107.632 217.018C107.632 217.208 107.784 217.363 107.971 217.363C108.159 217.363 108.311 217.208 108.311 217.018C108.311 216.828 108.159 216.674 107.971 216.674Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 219.785C108.805 219.785 108.653 219.939 108.653 220.129C108.653 220.319 108.805 220.473 108.992 220.473C109.18 220.473 109.332 220.319 109.332 220.129C109.332 219.939 109.18 219.785 108.992 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 219.785C110.85 219.785 110.698 219.939 110.698 220.129C110.698 220.319 110.85 220.473 111.038 220.473C111.225 220.473 111.377 220.319 111.377 220.129C111.377 219.939 111.225 219.785 111.038 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 218.749C109.826 218.749 109.674 218.903 109.674 219.093C109.674 219.283 109.826 219.437 110.013 219.437C110.201 219.437 110.353 219.283 110.353 219.093C110.353 218.903 110.201 218.749 110.013 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 218.749C107.784 218.749 107.632 218.903 107.632 219.093C107.632 219.283 107.784 219.437 107.971 219.437C108.159 219.437 108.311 219.283 108.311 219.093C108.311 218.903 108.159 218.749 107.971 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 220.82C109.826 220.82 109.674 220.975 109.674 221.165C109.674 221.355 109.826 221.509 110.013 221.509C110.201 221.509 110.353 221.355 110.353 221.165C110.353 220.975 110.201 220.82 110.013 220.82Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 220.82C107.784 220.82 107.632 220.975 107.632 221.165C107.632 221.355 107.784 221.509 107.971 221.509C108.159 221.509 108.311 221.355 108.311 221.165C108.311 220.975 108.159 220.82 107.971 220.82Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 217.713C108.805 217.713 108.653 217.867 108.653 218.058C108.653 218.248 108.805 218.402 108.992 218.402C109.18 218.402 109.332 218.248 109.332 218.058C109.332 217.867 109.18 217.713 108.992 217.713Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 217.713C110.85 217.713 110.698 217.867 110.698 218.058C110.698 218.248 110.85 218.402 111.038 218.402C111.225 218.402 111.377 218.248 111.377 218.058C111.377 217.867 111.225 217.713 111.038 217.713Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 223.931C108.805 223.931 108.653 224.085 108.653 224.275C108.653 224.465 108.805 224.619 108.992 224.619C109.18 224.619 109.332 224.465 109.332 224.275C109.332 224.085 109.18 223.931 108.992 223.931Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 222.895C109.826 222.895 109.674 223.049 109.674 223.239C109.674 223.429 109.826 223.583 110.013 223.583C110.201 223.583 110.353 223.429 110.353 223.239C110.353 223.049 110.201 222.895 110.013 222.895Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 222.895C107.784 222.895 107.632 223.049 107.632 223.239C107.632 223.429 107.784 223.583 107.971 223.583C108.159 223.583 108.311 223.429 108.311 223.239C108.311 223.049 108.159 222.895 107.971 222.895Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 221.856C108.805 221.856 108.653 222.01 108.653 222.2C108.653 222.39 108.805 222.544 108.992 222.544C109.18 222.544 109.332 222.39 109.332 222.2C109.332 222.01 109.18 221.856 108.992 221.856Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 221.856C110.85 221.856 110.698 222.01 110.698 222.2C110.698 222.39 110.85 222.544 111.038 222.544C111.225 222.544 111.377 222.39 111.377 222.2C111.377 222.01 111.225 221.856 111.038 221.856Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 215.639C104.718 215.639 104.566 215.793 104.566 215.983C104.566 216.173 104.718 216.327 104.906 216.327C105.093 216.327 105.245 216.173 105.245 215.983C105.245 215.793 105.093 215.639 104.906 215.639Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 215.639C106.763 215.639 106.611 215.793 106.611 215.983C106.611 216.173 106.763 216.327 106.951 216.327C107.138 216.327 107.29 216.173 107.29 215.983C107.29 215.793 107.138 215.639 106.951 215.639Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 214.603C105.743 214.603 105.591 214.757 105.591 214.947C105.591 215.137 105.743 215.291 105.93 215.291C106.117 215.291 106.269 215.137 106.269 214.947C106.269 214.757 106.117 214.603 105.93 214.603V214.603Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 216.674C105.743 216.674 105.591 216.828 105.591 217.018C105.591 217.208 105.743 217.363 105.93 217.363C106.117 217.363 106.269 217.208 106.269 217.018C106.269 216.828 106.117 216.674 105.93 216.674Z"
        fill="#DD0031"
      />
      <path
        d="M103.885 216.674C103.697 216.674 103.546 216.828 103.546 217.018C103.546 217.208 103.697 217.363 103.885 217.363C104.072 217.363 104.224 217.208 104.224 217.018C104.224 216.828 104.072 216.674 103.885 216.674Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 219.785C104.718 219.785 104.566 219.939 104.566 220.129C104.566 220.319 104.718 220.473 104.906 220.473C105.093 220.473 105.245 220.319 105.245 220.129C105.245 219.939 105.093 219.785 104.906 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 219.785C106.763 219.785 106.611 219.939 106.611 220.129C106.611 220.319 106.763 220.473 106.951 220.473C107.138 220.473 107.29 220.319 107.29 220.129C107.29 219.939 107.138 219.785 106.951 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 218.749C105.743 218.749 105.591 218.903 105.591 219.093C105.591 219.283 105.743 219.437 105.93 219.437C106.117 219.437 106.269 219.283 106.269 219.093C106.269 218.903 106.117 218.749 105.93 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M103.885 218.749C103.697 218.749 103.546 218.903 103.546 219.093C103.546 219.283 103.697 219.437 103.885 219.437C104.072 219.437 104.224 219.283 104.224 219.093C104.224 218.903 104.072 218.749 103.885 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 220.82C105.743 220.82 105.591 220.975 105.591 221.165C105.591 221.355 105.743 221.509 105.93 221.509C106.117 221.509 106.269 221.355 106.269 221.165C106.269 220.975 106.117 220.82 105.93 220.82Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 217.713C104.718 217.713 104.566 217.867 104.566 218.058C104.566 218.248 104.718 218.402 104.906 218.402C105.093 218.402 105.245 218.248 105.245 218.058C105.245 217.867 105.093 217.713 104.906 217.713Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 217.713C106.763 217.713 106.611 217.867 106.611 218.058C106.611 218.248 106.763 218.402 106.951 218.402C107.138 218.402 107.29 218.248 107.29 218.058C107.29 217.867 107.138 217.713 106.951 217.713Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 221.856C106.763 221.856 106.611 222.01 106.611 222.2C106.611 222.39 106.763 222.544 106.951 222.544C107.138 222.544 107.29 222.39 107.29 222.2C107.29 222.01 107.138 221.856 106.951 221.856Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 215.639C102.677 215.639 102.525 215.793 102.525 215.983C102.525 216.173 102.677 216.327 102.864 216.327C103.051 216.327 103.203 216.173 103.203 215.983C103.203 215.793 103.051 215.639 102.864 215.639Z"
        fill="#DD0031"
      />
      <path
        d="M101.843 216.674C101.656 216.674 101.504 216.828 101.504 217.018C101.504 217.208 101.656 217.363 101.843 217.363C102.03 217.363 102.182 217.208 102.182 217.018C102.182 216.828 102.03 216.674 101.843 216.674Z"
        fill="#DD0031"
      />
      <path
        d="M100.822 219.785C100.635 219.785 100.483 219.939 100.483 220.129C100.483 220.319 100.635 220.473 100.822 220.473C101.009 220.473 101.161 220.319 101.161 220.129C101.161 219.939 101.009 219.785 100.822 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 219.785C102.677 219.785 102.525 219.939 102.525 220.129C102.525 220.319 102.677 220.473 102.864 220.473C103.051 220.473 103.203 220.319 103.203 220.129C103.203 219.939 103.051 219.785 102.864 219.785Z"
        fill="#DD0031"
      />
      <path
        d="M101.843 218.749C101.656 218.749 101.504 218.903 101.504 219.093C101.504 219.283 101.656 219.437 101.843 219.437C102.03 219.437 102.182 219.283 102.182 219.093C102.182 218.903 102.03 218.749 101.843 218.749V218.749Z"
        fill="#DD0031"
      />
      <path
        d="M100.822 217.713C100.635 217.713 100.483 217.867 100.483 218.058C100.483 218.248 100.635 218.402 100.822 218.402C101.009 218.402 101.161 218.248 101.161 218.058C101.161 217.867 101.009 217.713 100.822 217.713Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 217.713C102.677 217.713 102.525 217.867 102.525 218.058C102.525 218.248 102.677 218.402 102.864 218.402C103.051 218.402 103.203 218.248 103.203 218.058C103.203 217.867 103.051 217.713 102.864 217.713Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="202"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="230">
          Apply
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="14"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136.359" y="164.032">
          ~10 MONTHS PRE-GRAND OPENING
        </tspan>
      </text>
      <rect x="82" y="110" width="44" height="44" rx="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.59 122.929L114.606 126.43C114.693 126.593 114.686 126.789 114.588 126.947C114.494 127.105 114.321 127.202 114.135 127.202H113.35V140.847C113.35 141.114 113.132 141.331 112.862 141.333H95.1336C94.862 141.333 94.6419 141.116 94.6419 140.847V127.202H93.8573C93.6712 127.202 93.4989 127.105 93.404 126.947C93.3098 126.787 93.3098 126.589 93.404 126.43L95.4265 122.929C95.5172 122.77 95.6854 122.671 95.8694 122.667H112.137C112.325 122.666 112.498 122.766 112.59 122.929ZM111.833 123.7H96.1762L94.7709 126.157H113.252L113.075 125.851C113.041 125.862 113.006 125.869 112.97 125.871C112.735 125.871 112.543 125.684 112.541 125.451C112.54 125.337 112.587 125.227 112.67 125.148L112.116 124.186C112.132 124.229 112.142 124.275 112.144 124.321C112.144 124.555 111.952 124.745 111.715 124.745C111.478 124.745 111.286 124.555 111.286 124.321C111.286 124.087 111.478 123.897 111.715 123.897C111.838 123.897 111.956 123.952 112.035 124.045L111.833 123.7ZM104.493 140.32V132.688H110.421V140.32H104.493ZM98.122 130.482L97.2154 131.778H110.853L109.95 130.482H98.122ZM97.6408 132.688H103.593V140.32H97.6408V132.688ZM111.31 140.365H112.384V127.202H111.816V127.777C111.816 128.045 111.596 128.263 111.324 128.263C111.053 128.263 110.833 128.045 110.833 127.777V127.202H109.713V127.777C109.713 128.045 109.493 128.263 109.222 128.263C108.95 128.263 108.73 128.045 108.73 127.777V127.202H107.611V127.777C107.626 127.96 107.536 128.136 107.378 128.232C107.22 128.328 107.021 128.328 106.863 128.232C106.705 128.136 106.615 127.96 106.631 127.777V127.202H105.511V127.777C105.511 128.045 105.291 128.263 105.02 128.263C104.748 128.263 104.528 128.045 104.528 127.777V127.202H103.402V127.777C103.417 127.96 103.327 128.136 103.169 128.232C103.011 128.328 102.812 128.328 102.654 128.232C102.496 128.136 102.406 127.96 102.422 127.777V127.202H101.302V127.777C101.302 128.045 101.082 128.263 100.811 128.263C100.539 128.263 100.319 128.045 100.319 127.777V127.202H99.1996V127.777C99.1996 128.045 98.9795 128.263 98.708 128.263C98.4364 128.263 98.2163 128.045 98.2163 127.777V127.202H97.1039V127.777C97.1195 127.96 97.0297 128.136 96.8717 128.232C96.7136 128.328 96.5143 128.328 96.3563 128.232C96.1982 128.136 96.1084 127.96 96.124 127.777V127.202H95.6254V140.365H96.7587V132.66H96.3646C96.1992 132.66 96.0471 132.57 95.9697 132.425C95.8922 132.281 95.9019 132.106 95.995 131.971L97.5189 129.789C97.601 129.669 97.7381 129.597 97.885 129.596H110.184C110.332 129.597 110.47 129.669 110.554 129.789L112.074 131.971C112.167 132.105 112.177 132.28 112.1 132.424C112.024 132.568 111.873 132.659 111.708 132.66H111.289L111.31 140.365Z"
        fill="#DD0031"
      />
      <ellipse
        cx="98.2651"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="99.109"
        cy="131.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="101.578"
        cy="131.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="104.047"
        cy="131.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="106.519"
        cy="131.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="108.988"
        cy="131.202"
        rx="0.428912"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="95.7963"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="103.206"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="100.734"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="97.0131"
        cy="124.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="101.951"
        cy="124.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="99.482"
        cy="124.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="105.647"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="110.585"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="108.116"
        cy="125.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="104.392"
        cy="124.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="109.333"
        cy="124.331"
        rx="0.428912"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="106.864"
        cy="124.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="110"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="137.76">
          Activate
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="5.5" y="172.608">
          {dayjs(recruitPhase1Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase1Date)
            ? dayjs().isBefore(recruitPhase2Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path d="M18 194V184L28 194L38 184V194H28H18Z" />
        <rect width="60" height="20" transform="translate(38 194) rotate(90)" />
        <path d="M18 254H38L28 264L18 254Z" />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="4.5" y="284.608">
          {dayjs(recruitPhase2Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase2Date)
            ? dayjs().isBefore(recruitPhase3Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path d="M18 306V296L28 306L38 296V306H28H18Z" />
        <rect width="20" height="20" transform="translate(38 306) rotate(90)" />
        <path d="M18 326H38L28 336L18 326Z" />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="2" y="356.608">
          {dayjs(recruitPhase3Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase3Date)
            ? dayjs().isBefore(recruitPhase4Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path d="M18 378V368L28 378L38 368V378H28H18Z" />
        <rect
          width="100"
          height="20"
          transform="translate(38 378) rotate(90)"
        />
        <path d="M18 478H38L28 488L18 478Z" />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="3" y="508.608">
          {dayjs(recruitPhase4Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase4Date)
            ? dayjs().isBefore(recruitPhase5Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path d="M18 530V520L28 530L38 520V530H28H18Z" />
        <rect
          width="180"
          height="20"
          transform="translate(38 530) rotate(90)"
        />
        <path d="M18 710H38L28 720L18 710Z" />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="3.5" y="740.608">
          {dayjs(recruitPhase5Date).format("MMM DD")}
        </tspan>
      </text>
      <defs>
        <clipPath id="clip0_2_443">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(92 608)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default StandardSelection;
